"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@/lib/utils";

function RequiredMark() {
  return (
    <>
      <span
        data-slot="required-mark"
        className="text-destructive"
        aria-hidden="true"
      >
        *
      </span>
      <span className="sr-only">（必須）</span>
    </>
  );
}

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & {
  required?: boolean;
};

function Label({
  className,
  children,
  required = false,
  ...props
}: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex select-none items-center gap-1 text-sm font-semibold leading-5 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        className
      )}
      {...props}
    >
      {children}
      {required && <RequiredMark />}
    </LabelPrimitive.Root>
  );
}

export { Label, RequiredMark };
